commusoftCommon.filter('nospace', function () {
    return function (input) {
        var string  = input.replace(' ', '_');
        return string;
    };
});